import { render, staticRenderFns } from "./updateNameSuccess.vue?vue&type=template&id=60c0630e"
import script from "./updateNameSuccess.vue?vue&type=script&lang=js"
export * from "./updateNameSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports